export default function (VirtualKeyboard) {
    return VirtualKeyboard.addLayout({
        code: 'AR-KU',
        name: 'Kurdish Arabic',
        normal: "`١٢٣٤٥٦٧٨٩٠-=\\قوهرتییئىئۆپ[]ئاسدفگهجكل;'زخچڤبنم,./",
        shift: { 0: '~!@#$٪^&*()_+|ثشئى̌ڒطێوووۊ', 24: '{}اصذ', 30: 'غحژ', 34: 'ڵ:"ظ', 39: 'ضعلالا̌ء<>?' }
    })
}
